module.exports = __webpack_public_path__ + "img/icon-return.d608399e.svg";